import { render, staticRenderFns } from "./Simulate.vue?vue&type=template&id=2afde25e"
import script from "./Simulate.vue?vue&type=script&lang=js"
export * from "./Simulate.vue?vue&type=script&lang=js"
import style0 from "./Simulate.vue?vue&type=style&index=0&id=2afde25e&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/Users/afonsomonteiro/onboarding/onboarding/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2afde25e')) {
      api.createRecord('2afde25e', component.options)
    } else {
      api.reload('2afde25e', component.options)
    }
    module.hot.accept("./Simulate.vue?vue&type=template&id=2afde25e", function () {
      api.rerender('2afde25e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Simulate.vue"
export default component.exports